module.exports = __webpack_public_path__ + "static/media/consent_video.7d21ad5d.mp3";